import React, {createContext, useContext} from 'react';
import {TranscriptSortKey} from '../AiInvestigateUtils';

export interface TranscriptPanelContextValue {
  selectedSortKey: string;
}

const TranscriptPanelContext = createContext<
  TranscriptPanelContextValue | undefined
>(undefined);

export const useTranscriptPanelSort = (): string => {
  const context = useContext(TranscriptPanelContext);
  return context?.selectedSortKey ?? TranscriptSortKey.ModifiedNewest;
};

export default TranscriptPanelContext;
